import { useState } from "react"
import AuthUser from './AuthUser';
import { Link } from 'react-router-dom';
import { LoginToaster, showLoginErrorByStatus, showLoginToast } from "./LoginToast";

export default function LoginJob() {
    const {http,setToken} = AuthUser();
    const [email,setEmail] = useState();
    const [password,setPassword] = useState();

    const submitForm = () =>{
        // api call
        http.post('/login_job', {email: email, password: password})
        .then((res) => {
            if (res.error && res.error === "Unauthorized") {
                showLoginToast({
                    title: "Not authorized",
                    message: "You are not authorized to view this content. Please log in.",
                    variant: "error",
                });
            }
            setToken(res.data.user, res.data.access_token);
        })
        .catch((error) => {
            if (error.response?.status) {
                showLoginErrorByStatus(error.response.status);
            }
        });
    }

    return(
        <div className="row justify-content-center pt-5">
            <div className="col-sm-6 col-md-6">
            <img
              src="/team.jpeg"
              alt="team"
              style={{ maxWidth: "100%", height: "auto" }}
            />
            </div>
            <div className="col-sm-6 col-md-6">
            <LoginToaster />
                <div className="card p-4 wall">
                    <h1 className="text-center mb-3">Login </h1>
                    <div className="form-group">
                        <label>Email address:</label>
                        <input type="email" className="form-control" placeholder="Enter email"
                            onChange={e=>setEmail(e.target.value)}
                        id="email" />
                    </div>
                    <div className="form-group mt-3">
                        <label>Password:</label>
                        <input type="password" className="form-control" placeholder="Enter password"
                            onChange={e => setPassword(e.target.value)}
                        id="pwd" />
                    </div>
                   <Link to='/forgot' className="mt-3">Forgot password?</Link>
                    <button type="button" onClick={submitForm} className="btn btn-primary mt-4">Login</button>
                </div>
            </div>
        </div>
    )
}